(() => {
  'use strict';

  const escapeHtml = (value = '') => String(value).replace(/[&<>'\"]/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '\"': '&quot;',
  }[character]));

  const safeProductUrl = (url) => {
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin ? `${parsed.pathname}${parsed.search}${parsed.hash}` : '#';
    } catch (_) {
      return '#';
    }
  };

  const cleanProductTitle = (title = '') => String(title)
    .split('|')[0]
    .replace(/^925 Sterling Silver\s+/i, '')
    .replace(/^Vzyra\s+/i, '')
    .trim();

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'CAD';
    const locale = document.documentElement.lang || 'en-CA';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    } catch (_) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const initStickyAtc = () => {
    const bar = document.querySelector('[data-vzyra-sticky-atc]');
    const mainButton = document.querySelector('.product-form__submit');
    if (!bar || !mainButton) return;

    const stickyButton = bar.querySelector('button');
    const stickyPrice = bar.querySelector('[data-vzyra-sticky-price]');
    const productSection = mainButton.closest('.shopify-section');
    const priceRoot = productSection?.querySelector('.price');

    const sync = () => {
      if (stickyPrice && priceRoot) stickyPrice.textContent = priceRoot.textContent.trim().replace(/\s+/g, ' ');
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.querySelector('span')?.textContent?.trim() || mainButton.textContent.trim();
    };

    stickyButton.addEventListener('click', () => {
      if (!mainButton.disabled) mainButton.click();
    });

    const observer = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.15 });
    observer.observe(mainButton);

    if (priceRoot) new MutationObserver(sync).observe(priceRoot, { subtree: true, childList: true, characterData: true });
    new MutationObserver(sync).observe(mainButton, { subtree: true, childList: true, attributes: true });
    sync();
  };

  const initRecentlyViewed = async () => {
    const root = document.querySelector('[data-vzyra-recently-viewed]');
    if (!root) return;

    const current = root.dataset.currentProduct;
    const limit = Number(root.dataset.limit || 4);
    const storageKey = 'vzyra-recently-viewed';
    let handles = [];

    try { handles = JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (_) { handles = []; }
    handles = handles.filter(Boolean).filter((handle) => handle !== current);

    if (current) {
      const updated = [current, ...handles].slice(0, 12);
      localStorage.setItem(storageKey, JSON.stringify(updated));
    }

    const displayHandles = handles.slice(0, limit);
    if (!displayHandles.length) return;

    const grid = root.querySelector('[data-vzyra-recent-grid]');
    if (!grid) return;

    const products = await Promise.all(displayHandles.map(async (handle) => {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
        if (!response.ok) return null;
        return await response.json();
      } catch (_) { return null; }
    }));

    products.filter(Boolean).forEach((product) => {
      const image = product.featured_image || product.images?.[0];
      const title = escapeHtml(cleanProductTitle(product.title));
      const productUrl = safeProductUrl(product.url);
      const imageUrl = image ? escapeHtml(image) : '';
      const card = document.createElement('article');
      card.className = 'vzyra-recent-card';
      card.innerHTML = `
        <a class="vzyra-recent-card__media" href="${productUrl}">
          ${image ? `<img src="${imageUrl}" alt="${title}" loading="lazy" width="600" height="600">` : ''}
        </a>
        <h3 class="vzyra-recent-card__title"><a href="${productUrl}">${title}</a></h3>
        <div class="vzyra-recent-card__price">${money(product.price)}</div>
      `;
      grid.appendChild(card);
    });

    if (grid.children.length) root.hidden = false;
  };

  const init = () => {
    initStickyAtc();
    initRecentlyViewed();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', init);
})();
